import { supabase } from "@/integrations/supabase/client";

interface SecurityLogData {
  action_type: string;
  resource_type: string;
  resource_id?: string;
  metadata?: Record<string, any>;
}

export const useSecurityLogging = () => {
  const logSecurityEvent = async (data: SecurityLogData) => {
    try {
      const { data: result, error } = await supabase.functions.invoke('log-security-event', {
        body: data
      });

      if (error) {
        console.error('Security logging error:', error);
        return { success: false, error: error.message };
      }

      return { success: true, data: result };
    } catch (error) {
      console.error('Security logging error:', error);
      return { success: false, error: 'Failed to log security event' };
    }
  };

  return { logSecurityEvent };
};